import useSWR from 'swr';
import { getReturnSettings } from 'services/return-settings.service';

// Shared SWR key — the Settings toggle calls mutate() on this exact key after a successful
// save, which instantly pushes the fresh value to every subscriber (the sidebar included)
// without needing a page reload or even a route change. The sidebar is a persistent layout
// component that never remounts between navigations, so a plain useEffect-on-mount fetch
// could never see a change made later on the Settings page — this is why it needs to be a
// shared, actively-invalidated cache entry instead.
export const RETURN_SETTINGS_ENABLED_KEY = 'return-settings-enabled';

const fetchReturnsEnabled = () => getReturnSettings().then((response) => !!response?.data?.enabled);

// Only fetches when shouldCheck is true, so businesses that can never see the Returns
// section (wrong role, legal/dental verticals) never fire this request at all.
export const useReturnsEnabled = (shouldCheck) => {
  const { data, isLoading } = useSWR(shouldCheck ? RETURN_SETTINGS_ENABLED_KEY : null, fetchReturnsEnabled);

  return { returnsEnabled: !!data, isLoading: shouldCheck ? isLoading : false };
};
